import React, { FC } from 'react';
import { Button } from '../common/Button';
import { Typography } from '../common/Typography';
import { useLicenseAssignment } from './LicenseAssignmentContext';

export const CancelButton: FC = () => {
  const { assigningStatus, toggleModal } = useLicenseAssignment();
  return (
    <Button variant='outlined' onClick={toggleModal} disabled={assigningStatus === 'loading'}>
      <Typography>Cancel</Typography>
    </Button>
  );
};
